import BaseModel from './BaseModel'

export default class ServiceRequest extends BaseModel {
  // ... ServiceRequest-specific methods or overrides ...
}
